(function () {
    'use strict';

    angular
        .module('app.accountSettings')
        .component('sc3HomeCourse', {
            templateUrl: 'app/account-settings/home-course.component.html',
            controller: HomeCourseComponent,
            bindings: { facility: '<', course: '<', tee: '<', returnState: '<' }
        });

    var copy = angular.copy;

    HomeCourseComponent.$inject = ['$state', 'Course', 'Member', 'user', 'alert', 'accountSettings_resources', 'courseStatus'];
    function HomeCourseComponent($state, Course, Member, user, alert, resources, courseStatus) {
        var ctrl = this;

        // Properties
        ctrl.defaults = createDefaults();

        // Methods
        ctrl.submit = submit;
        ctrl.cancel = cancel;
        ctrl.facilityChange = facilityChange;

        // Validation
        ctrl.isAssociationFacility = isAssociationFacility;
        ctrl.isAssociationCourse = isAssociationCourse;

        ///////////////////////

        function submit() {
            if (ctrl.form.$valid) {
                Member.saveHomeCourseAndTee({ id: user.id }, ctrl.defaults, true).$promise
                    .then(updateUser)
                    .then(showSuccess)
                    .then(redirect)
                    .catch(showError);
            }

            function updateUser() {
                copy(ctrl.defaults, user.scoreDefaults);
            }
            function showSuccess() {
                return alert.success(resources.saveCourseAndTeeSucceeded);
            }
            function redirect() {
                $state.go(ctrl.returnState);
            }
            function showError() {
                alert.error(resources.saveCourseAndTeeFailed);
            }
        }
        function cancel() {
            $state.go(ctrl.returnState);
        }

        function facilityChange() {
            var facility = ctrl.facility,
                courseCtrl = ctrl.form.course;

            if (courseCtrl)
                courseCtrl.$setUntouched();

            if (facility)
                Course.getCourses({ facilityId: facility.id }, success, error);

            function success(result) {
                facility.courses = result;
                if (facility.courses.length === 1) 
                    ctrl.course = facility.courses[0]
            }
            function error() {
                alert.error(resources.courseListRequestFailed);
            }
        }
        function isAssociationCourse(course) {
            return !course || course.courseStatus === courseStatus.Active;
        }
        function isAssociationFacility(facility) {
            return !facility || !facility.courses || facility.courses.length !== 1 || isAssociationCourse(facility.courses[0]);
        }

        function createDefaults() {
            var result = copy(user.scoreDefaults);
            Object.defineProperties(result, {
                facilityId: { get: function () { return ctrl.facility && ctrl.facility.id || null; } },
                facilityName: { get: function () { return ctrl.facility && ctrl.facility.name || null; } },
                nationalAssociation: { get: function () { return ctrl.facility && ctrl.facility.nationalAssociation || null; } },
                courseId: { get: function () { return ctrl.course && ctrl.course.id || null; } },
                teeId: { get: function () { return ctrl.tee && ctrl.tee.id || null; } },
            });
            return result;
        }
    }
})();